export default __webpack_public_path__ + "static/media/regulatory--give-way-to-oncoming-traffic--g2.51aed85b.png";